import { useState, useEffect } from "react";
import { MOBILE_BREAKPOINT } from "../utils/common";

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobileView: window.innerWidth <= MOBILE_BREAKPOINT,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobileView: window.innerWidth <= MOBILE_BREAKPOINT,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
